import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsOpportunityItemActionComponent } from './opportunity-item-action.component';
import { CmpsOpportunityItemComponent } from './opportunity-item.component';

@NgModule({
    declarations: [
        CmpsOpportunityItemComponent,
        CmpsOpportunityItemActionComponent,
    ],
    imports: [CommonModule, CmpsIconModule],
    exports: [CmpsOpportunityItemComponent, CmpsOpportunityItemActionComponent],
})
export class CmpsOpportunityItemModule {}
